import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from '../app/components/page-not-found/page-not-found.component';
import { FrameComponent } from '../app/components/frame/frame.component';
import { MainComponent } from '../app/components/main/main.component';
import { ArticleComponent } from '../app/components/article/article.component';
import { WelcomeComponent } from '../app/components/welcome/welcome.component';
import { ContributorsComponent } from '../app/components/contributors/contributors.component';
import { DataResolve } from '../app/resolves/data.resolve';
import { FrontPageComponent } from '../app/components/front-page/front-page.component';

const appRoutes: Routes = [
  {
    path: '',
    component: WelcomeComponent
  },
  {
    path: ':path',
    component: FrameComponent,
    resolve: {
      data: DataResolve
    },
    children: [
      { path: '',
        component: MainComponent,
        children: [
          {
            path: '',
            component: FrontPageComponent
          },
          {
            path: 'articles/:id',
            component: ArticleComponent
          },
          {
            path: 'contributors',
            component: ContributorsComponent
          }
        ]
      }
    ]
  },
  { path: 'pagenotfound', component: PageNotFoundComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    DataResolve
  ]
})
export class RoutingModule {}



// WEBPACK FOOTER //
// ./src/routing/route.module.ts